const API_BASE_URL = 'https://vat-accounting-api.verydesi24.workers.dev';

class ApiService {
  async request(endpoint, options = {}) {
    const url = `${API_BASE_URL}${endpoint}`;
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    };

    if (config.body) {
      config.body = JSON.stringify(config.body);
    }

    try {
      const response = await fetch(url, config);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.error || 'API request failed');
      }
      
      return data;
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Authentication
  async login(email, password) {
    return this.request('/api/auth/login', {
      method: 'POST',
      body: { email, password }
    });
  }

  // Google Sheets
  async testSheetsConnection() {
    return this.request('/api/sheets/test', {
      method: 'POST'
    });
  }

  // Transactions
  async getTransactions() {
    return this.request('/api/transactions');
  }

  // Add transaction
  async addTransaction(transaction) {
    return this.request('/api/transactions/add', {
      method: 'POST',
      body: transaction
    });
  }
}

export const apiService = new ApiService();